import { Directive } from '@angular/core';
import { ThirdPillarMetadata } from 'src/app/_types/lead.types';
import { getCentralisationInsurerLabel } from 'src/app/enums/centralisation-insurer.enum';
import { getSexEnumLabel } from 'src/app/enums/sex.enum';
import {
  getOwnDescriptionEnum,
  getSavingReasonEnumLabel,
  getThirdPillarSituationLabel,
  ThirdPillarSituationEnum,
} from 'src/app/enums/third-pillar.enum';
import { getBooleanLabel } from 'src/app/helpers/utils';

import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export abstract class ThirdPillarMetadataComponentAbstract extends BaseMetadataComponent<ThirdPillarMetadata> {
  getBooleanLabel = getBooleanLabel;

  getOwnDescriptionLabel = getOwnDescriptionEnum;

  getSavingReasonLabel = getSavingReasonEnumLabel;

  getThirdPillarSituationLabel = getThirdPillarSituationLabel;

  Situation = ThirdPillarSituationEnum;

  getSexEnumLabel = getSexEnumLabel;

  getCentralisationInsurerLabel = getCentralisationInsurerLabel;
}
